function getAssetUrl($url) {
  return `${window.location.protocol}//${window.location.host}/${$url}`;
}

export { getAssetUrl };
